define(["require", "exports", "jquery", "knockout", "log", "../shared/exportData", "./tools", "./LookupDataSources"], function (require, exports, $, ko, log, ExportData, tools, LookupDataSources) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.KendoUtils = void 0;
    function adjustDropDownWidth(e) {
        var listContainer = e.sender.list.closest(".k-list-container");
        listContainer.width(listContainer.width() + kendo.support.scrollbar());
    }
    var KendoUtils = /** @class */ (function () {
        function KendoUtils() {
            this.defaultDataSource = {
                schema: {
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                pageSize: 100,
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                error: function (e) {
                    if (e.errors) {
                        if (typeof e.errors === "string") {
                            tools.error("Errors: " + e.errors);
                        }
                        else {
                            tools.error("Errors: " + e.errors.join("; "));
                        }
                    }
                    else {
                        tools.error(e.errorThrown);
                    }
                }
            };
            this.defaultGridOptions = {
                sortable: true,
                pageable: {
                    refresh: true,
                    pageSizes: [10, 25, 50, 100, 250, 500, 750, 1000, 2000, 3000, 5000],
                    buttonCount: 5
                }
            };
            this.hasDetailsToExport = false;
            this.defaultOptions = {
                minWidth: {
                    enabled: true,
                    minWidth: 150
                }
            };
            this.gridId = "";
            this.gridContainer = "";
            this.expandedDetails = {};
        }
        KendoUtils.prototype.initGrid = function (options) {
            var self = this;
            self.gridId = options.gridId;
            self.controller = options.controller;
            self.gridContainer = "#" + options.gridId;
            self.options = options;
            $.extend(true, self.defaultOptions, self.options);
            $.extend(true, self.defaultDataSource, options.dataSourceOptions);
            $.extend(true, self.defaultGridOptions, options.gridOptions);
            var columns = self.defaultGridOptions.columns;
            if (options.allowBulkEdits && options.allowBulkEdits.enabled) {
                //add actions column
                var actions = {
                    field: "",
                    data_id: "bulkEditField",
                    headerTemplate: '<input type="checkbox" id="checkAll" />',
                    template: '<input type="checkbox" class="check-row" data-id="#=Id#" ' + (options.allowBulkEdits.customDataAttributes || "") + "/>",
                    filterable: false,
                    sortable: false,
                    editable: false,
                    width: "30px"
                };
                columns.splice(0, 0, actions);
            }
            var settings = KendoUtils.getGridSettings(self.gridId);
            if (settings && settings.options) {
                var savedOptions = settings.options;
                console.log('apply saved grid settings');
                delete savedOptions.autoBind;
                delete savedOptions.resizable;
                delete savedOptions.reorderable;
                delete savedOptions.mobile;
                delete savedOptions.height;
                delete savedOptions.scrollable;
                delete savedOptions.columnMenu;
                delete savedOptions.toolbar;
                if (settings.pageSize) {
                    self.defaultDataSource.pageSize = settings.pageSize;
                }
                savedOptions.columns.forEach(function (column) {
                    var defColumn;
                    if (column.field) {
                        defColumn = columns.find(function (item) {
                            return item.field === column.field;
                        });
                    }
                    else if (column.data_id) {
                        defColumn = columns.find(function (item) {
                            return item.data_id === column.data_id;
                        });
                    }
                    else {
                        defColumn = columns.find(function (item) {
                            return !item.data_id && !item.field;
                        });
                    }
                    if (defColumn) {
                        if (defColumn.template) {
                            column.template = defColumn.template;
                        }
                        $.extend(true, defColumn, column);
                    }
                });
                self.defaultGridOptions.columns = savedOptions.columns;
                $.extend(true, self.defaultGridOptions, savedOptions);
                columns = self.defaultGridOptions.columns;
            }
            if (options.gridOptions.pageable) {
                $.extend(self.defaultGridOptions.pageable, options.gridOptions.pageable);
            }
            if (options.dataSourceOptions.error) {
                self.defaultDataSource.error = function (e) {
                    if (e.errors) {
                        tools.error("Errors: " + e.errors.join("; "));
                    }
                    else {
                        tools.error(e.errorThrown);
                    }
                    options.dataSourceOptions.error(e);
                };
            }
            if (options.dataSourceOptions.transport) {
                self.defaultDataSource.transport.parameterMap = function (options, operation) {
                    function convert(filters) {
                        ko.utils.arrayForEach(filters, function (item) {
                            if (item.filters) {
                                convert(item.filters);
                            }
                            if (item.value instanceof Date) {
                                item.value = kendo.toString(item.value, "d");
                            }
                        });
                    }
                    if (options.filter && options.filter.filters) {
                        convert(options.filter.filters);
                    }
                    if (operation === "update") {
                        for (var propertyName in options) {
                            if (options[propertyName] instanceof Date) {
                                options[propertyName] = kendo.toString(options[propertyName], "d");
                            }
                        }
                    }
                    if (operation === "destroy") {
                        for (var propertyName in options) {
                            if (options[propertyName] instanceof Date) {
                                options[propertyName] = kendo.toString(options[propertyName], "d");
                            }
                        }
                    }
                    log.log(operation, self.gridContainer);
                    return options;
                };
            }
            if (self.defaultGridOptions.filterable) {
                if (self.defaultGridOptions.filterable.messages) {
                    self.defaultGridOptions.filterable.messages.isTrue = "Yes";
                    self.defaultGridOptions.filterable.messages.isFalse = "No";
                }
                else {
                    self.defaultGridOptions.filterable.messages = {
                        isTrue: "Yes",
                        isFalse: "No"
                    };
                }
            }
            //update columns filter data sources
            var lookupDataSources = new LookupDataSources();
            ko.utils.arrayForEach(columns, function (item) {
                if (item.filterable && item.filterable.cell && item.filterable.cell.dataSourceName) {
                    var dataSource = lookupDataSources.createLookupDataSource(item.filterable.cell.dataSourceName);
                    item.filterable.cell.dataSource = dataSource;
                    var virtual = undefined;
                    if (item.filterable.cell.dataSourceName === "Customers") {
                        virtual = {
                            itemHeight: 26,
                            valueMapper: function (options) {
                                $.ajax({
                                    url: "/LookupDataSources/GetRecordIndex",
                                    type: "GET",
                                    data: self.convertValues(options.value, "Customer", "Name"),
                                    success: function (response) {
                                        options.success(response.Data);
                                    }
                                });
                            }
                        };
                    }
                    if (item.filterable.cell.templateName === "kendoDropDownList") {
                        var dropDownOptions = {
                            dataSource: dataSource,
                            dataTextField: item.filterable.cell.dataTextField || item.field,
                            dataValueField: item.filterable.cell.dataValueField || item.field,
                            valuePrimitive: true,
                            virtual: virtual,
                            filter: "contains",
                            open: adjustDropDownWidth,
                            close: function (e) {
                                //log.log(e.sender);
                                e.sender.element[0].parentElement.nextElementSibling.focus();
                            }
                        };
                        if (options.parentContainer) {
                            dropDownOptions["popup"] = {
                                appendTo: options.parentContainer
                            };
                        }
                        item.filterable.cell.template = function (args) {
                            var dropdown = args.element.kendoDropDownList(dropDownOptions).data("kendoDropDownList");
                            dropdown.list.width("auto");
                        };
                        item.filterable.ui = function (element) {
                            var dropdown = element.kendoDropDownList(dropDownOptions).data("kendoDropDownList");
                            dropdown.list.width("auto");
                        };
                    }
                }
            });
            if (options.enableExport) {
                self.defaultGridOptions.excel = {
                    allPages: true,
                    fileName: options.enableExport.entityName
                };
                if (options.enableExport.enablePdf) {
                    self.defaultGridOptions.pdf = {
                        allPages: true,
                        fileName: options.enableExport.entityName
                    };
                }
            }
            self.defaultGridOptions.dataSource = self.defaultDataSource;
            $(self.gridContainer).kendoGrid(self.defaultGridOptions);
            if (options.allowBulkEdits && options.allowBulkEdits.enabled) {
                $(self.gridContainer + " #checkAll").on("click", function (event) {
                    var checked = $(event.currentTarget).prop("checked");
                    $(self.gridContainer + " .check-row").prop("checked", checked);
                });
            }
            var grid = $(self.gridContainer).data("kendoGrid");
            if (self.defaultGridOptions.pageable) {
                grid.bind("page", function (e) {
                    e.sender.content.scrollTop(0);
                });
            }
            if (options.showPagerOnTop) {
                var wrapper = $('<div class="k-pager-wrap k-grid-pager pagerTop"/>').insertBefore(grid.element.children("div.k-grid-header"));
                grid.pagerTop = new kendo.ui.Pager(wrapper.get(0), $.extend({}, grid.options.pageable, { dataSource: grid.dataSource }));
                grid.element.height("").find(".pagerTop").css("border-width", "0 0 1px 0");
            }
            if (options.enableStickyHeader) {
                var gridContent = $(".k-grid-content", grid.element);
                var clickedOnScrollbar = function (mouseX) {
                    if ($(gridContent).outerWidth() <= mouseX) {
                        return true;
                    }
                    return false;
                };
                var isMouseDouwn = false;
                $(window).mousedown(function (e) {
                    if (clickedOnScrollbar(e.clientX)) {
                        isMouseDouwn = true;
                    }
                });
                $(window).mouseup(function () {
                    isMouseDouwn = false;
                    self.updateStickyHeader();
                });
                self.headerElement = $(".k-grid-header thead", grid.element)[0];
                grid.bind("detailExpand", function (e) {
                    var rowData = grid.dataItem(e.masterRow);
                    var masterRowClone = $(e.masterRow[0]).clone()[0];
                    var detailsHeaderClone = $(e.detailRow[0]).clone().show()[0];
                    $("tbody", detailsHeaderClone).remove();
                    $(".k-loading-mask", detailsHeaderClone).remove();
                    $(".k-grid-pager", detailsHeaderClone).remove();
                    var row = self.expandedDetails[rowData.Id] = {
                        masterRow: e.masterRow[0],
                        masterRowClone: masterRowClone,
                        detailRow: e.detailRow[0],
                        detailsHeader: $(".k-grid-header tr", e.detailRow[0])[0],
                        detailsHeaderClone: detailsHeaderClone,
                        isInHeader: false,
                        isVisible: true,
                        isDetailInHeader: false,
                        isDetailVisible: true
                    };
                    var detailsHandler = function () {
                        $(detailsHeaderClone).on("click.kendoGrid", "th", function (event) {
                            var columnIndex = $(event.currentTarget).index();
                            $($("th .k-link", row.detailsHeader).get(columnIndex)).trigger("click");
                            $(".k-icon", detailsHeaderClone).remove();
                            $(".k-link", event.currentTarget).html($($("th .k-link", row.detailsHeader).get(columnIndex)).html());
                            return false;
                        });
                    };
                    var detailGrid = $(".k-grid", e.detailRow).data("kendoGrid");
                    detailGrid.bind("columnResize", function () {
                        detailsHeaderClone = $(e.detailRow[0]).clone().show()[0];
                        $("tbody", detailsHeaderClone).remove();
                        $(".k-loading-mask", detailsHeaderClone).remove();
                        row.detailsHeaderClone = detailsHeaderClone;
                        detailsHandler();
                    });
                    $(masterRowClone).on("click.kendoGrid", ".k-plus, .k-minus", function () {
                        grid.collapseRow(row.masterRow);
                        row.isVisible = true;
                        if (row.isInHeader) {
                            row.isInHeader = false;
                            self.headerElement.removeChild(row.masterRowClone);
                            if (row.isDetailInHeader) {
                                row.isDetailInHeader = false;
                                self.headerElement.removeChild(row.detailsHeaderClone);
                            }
                            $(window).trigger("resize");
                        }
                        return false;
                    });
                    detailsHandler();
                });
                grid.bind("detailCollapse", function (e) {
                    var data = grid.dataItem(e.masterRow);
                    delete self.expandedDetails[data.Id];
                });
                gridContent.on("scroll", function () {
                    if (isMouseDouwn) {
                        return;
                    }
                    self.updateStickyHeader();
                });
            }
            //Initialize menu
            setTimeout(function () {
                var element = document.getElementById(self.gridId);
                if (element) {
                    var menu = $(".btn-group", element);
                    $("button, a", menu).on("click", function (e) {
                        var actionName = $(e.target).data("action");
                        var actionData = $(e.target).data("actiondata");
                        if (actionName) {
                            self.controller[actionName](actionData);
                            e.preventDefault();
                        }
                    });
                }
            });
            if (options.autoHeight) {
                var offset = options.autoHeight.totalOffset || 206;
                var autoHeightRunner = 0;
                $(window).resize(function () {
                    if (autoHeightRunner) {
                        clearTimeout(autoHeightRunner);
                    }
                    autoHeightRunner = setTimeout(function () {
                        self.resizeAutoHeight(offset);
                    }, 1);
                });
                autoHeightRunner = setTimeout(function () {
                    self.resizeAutoHeight(offset);
                }, 1);
                grid.bind("dataBound", function () {
                    if (autoHeightRunner) {
                        clearTimeout(autoHeightRunner);
                    }
                    autoHeightRunner = setTimeout(function () {
                        self.resizeAutoHeight(offset);
                    }, 0);
                    if (!grid.options.scrollable || !grid.options.scrollable.virtual) {
                        $(window).trigger("resize");
                        setTimeout(function () {
                            $(window).trigger("resize");
                        }, 300);
                    }
                });
            }
            if (self.defaultOptions.minWidth.enabled) {
                $(window).resize(function () {
                    setTimeout(function () {
                        self.autoWidthRunner = self.resizeAutoWidthRunner(self.gridContainer, self.autoWidthRunner);
                    });
                });
                self.autoWidthRunner = self.resizeAutoWidthRunner(self.gridContainer, self.autoWidthRunner);
                grid.bind("columnHide", function () {
                    self.autoWidthRunner = self.resizeAutoWidthRunner(self.gridContainer, self.autoWidthRunner);
                });
                grid.bind("columnShow", function () {
                    self.autoWidthRunner = self.resizeAutoWidthRunner(self.gridContainer, self.autoWidthRunner);
                });
            }
            if (!grid.options.scrollable || !grid.options.scrollable.virtual) {
                setTimeout(function () {
                    $(window).trigger("resize");
                }, 300);
            }
            if (options.customLoading) {
                grid.dataSource.bind("requestStart", function (e) {
                    $(".loader-container").show();
                });
                grid.dataSource.bind("requestEnd", function (e) {
                    $(".loader-container").hide();
                });
            }
        };
        KendoUtils.prototype.convertValues = function (value, tableName, orderByColumn) {
            var data = {};
            value = $.isArray(value) ? value : [value];
            for (var idx = 0; idx < value.length; idx++) {
                data["values[" + idx + "]"] = value[idx];
            }
            data.tableName = tableName;
            data.orderByColumn = orderByColumn;
            return data;
        };
        KendoUtils.prototype.removeHeadersFromHeader = function () {
            var self = this;
            var grid = self.getGridData();
            for (var index in self.expandedDetails) {
                if (self.expandedDetails.hasOwnProperty(index)) {
                    var row = self.expandedDetails[index];
                    grid.collapseRow(row.masterRow);
                    row.isVisible = true;
                    if (row.isInHeader) {
                        row.isInHeader = false;
                        self.headerElement.removeChild(row.masterRowClone);
                        if (row.isDetailInHeader) {
                            row.isDetailInHeader = false;
                            self.headerElement.removeChild(row.detailsHeaderClone);
                        }
                        $(window).trigger("resize");
                    }
                }
            }
            return false;
        };
        KendoUtils.prototype.updateStickyHeader = function () {
            var self = this;
            var grid = self.getGridData();
            var gridContent = $(".k-grid-content", grid.element);
            for (var index in self.expandedDetails) {
                if (self.expandedDetails.hasOwnProperty(index)) {
                    var row = self.expandedDetails[index];
                    //check if header top is visible
                    if (tools.isOnScreenTopTop(gridContent[0], row.masterRow, 0)) {
                        //log.log('header visible');
                        row.isVisible = true;
                        if (row.isInHeader) {
                            row.isInHeader = false;
                            self.headerElement.removeChild(row.masterRowClone);
                            $(window).trigger("resize");
                            log.log("remove header");
                        }
                    }
                    else {
                        //log.log('header not visible');
                        row.isVisible = false;
                        if (!row.isInHeader && tools.isOnScreenBottomTop(gridContent[0], row.detailRow, 0)) {
                            row.isInHeader = true;
                            self.headerElement.appendChild(row.masterRowClone);
                            $(window).trigger("resize");
                            log.log("add header");
                        }
                    }
                    //details header handler
                    if (tools.isOnScreenTopTop(gridContent[0], row.detailsHeader, 0)) {
                        //log.log('details header visible');
                        row.isDetailVisible = true;
                        if (row.isDetailInHeader) {
                            row.isDetailInHeader = false;
                            self.headerElement.removeChild(row.detailsHeaderClone);
                            $(window).trigger("resize");
                            log.log("remove detail header");
                        }
                    }
                    else {
                        //log.log('details header not visible');
                        row.isDetailVisible = false;
                        if (!row.isDetailInHeader && tools.isOnScreenBottomTop(gridContent[0], row.detailRow, 0)) {
                            row.isDetailInHeader = true;
                            self.headerElement.appendChild(row.detailsHeaderClone);
                            $(window).trigger("resize");
                            log.log("add detail header");
                        }
                    }
                    if (tools.isOnScreenBottomTop(gridContent[0], row.detailRow, 0)) {
                        //log.log('details visible');
                        if (!row.isInHeader && !row.isVisible) {
                            row.isInHeader = true;
                            self.headerElement.appendChild(row.masterRowClone);
                            $(window).trigger("resize");
                            log.log("add header");
                        }
                        if (!row.isDetailInHeader && !row.isDetailVisible) {
                            row.isDetailInHeader = true;
                            self.headerElement.appendChild(row.detailsHeaderClone);
                            $(window).trigger("resize");
                            log.log("add detail header");
                        }
                    }
                    else {
                        //log.log('details not visible');
                        if (row.isInHeader || row.isDetailInHeader) {
                            row.isInHeader = false;
                            row.isDetailInHeader = false;
                            self.headerElement.removeChild(row.masterRowClone);
                            self.headerElement.removeChild(row.detailsHeaderClone);
                            $(window).trigger("resize");
                            log.log("remove all headers");
                        }
                    }
                }
            }
        };
        KendoUtils.prototype.adjustStickyHeaderWidthAndPosition = function (detailsRows, gridContent) {
            log.log("adjust width");
            if (detailsRows && detailsRows.length > 0) {
                for (var i = 0; i < detailsRows.length; i++) {
                    var top;
                    var detailsRow = detailsRows[i];
                    var masterRow = $(detailsRow).closest(".k-detail-row").prev();
                    var masterRowPrev = masterRow.prevAll(".k-master-row").first();
                    var masterRowNext = masterRow.nextAll(".k-master-row").first();
                    var detailsHeader = $(".k-grid-header", detailsRow).not(".fake");
                    var stickyHeader = $(".fake", detailsRow);
                    if (!stickyHeader || stickyHeader.length === 0) {
                        stickyHeader = $(detailsHeader).clone();
                        stickyHeader.addClass("fake");
                        stickyHeader.insertAfter(detailsHeader);
                    }
                    if ($(detailsRow).is(":visible") && tools.isOnScreen(gridContent[0], detailsRow, masterRow.height())) {
                        if (masterRowPrev && masterRowPrev.length > 0) {
                            if (tools.isOnScreen(gridContent[0], masterRowPrev)) {
                                masterRow.removeClass("sticky-row");
                                masterRow.find("td").each(function (j) {
                                    masterRow.find("td").eq(j).css("width", "");
                                    masterRow.find("td").eq(j).find(".k-icon").width("");
                                });
                            }
                            else {
                                masterRowPrev.find("td").each(function (j) {
                                    masterRow.find("td").eq(j).width($(this).width());
                                    masterRow.find("td").eq(j).find(".k-icon").width($(this).width());
                                });
                                masterRow.width(masterRowPrev.width() + 9);
                                masterRow.addClass("sticky-row");
                                top = gridContent.scrollTop();
                                masterRow.css("top", top);
                            }
                        }
                        else if (masterRowNext && masterRowNext.length > 0) {
                            top = gridContent.scrollTop();
                            if (top === 0) {
                                masterRow.removeClass("sticky-row");
                                masterRow.find("td").each(function (j) {
                                    masterRow.find("td").eq(j).css("width", "");
                                    masterRow.find("td").eq(j).find(".k-icon").width("");
                                });
                            }
                            else {
                                masterRowNext.find("td").each(function (j) {
                                    masterRow.find("td").eq(j).width($(this).width());
                                    masterRow.find("td").eq(j).find(".k-icon").width($(this).width());
                                });
                                masterRow.width(masterRowNext.width() + 9);
                                masterRow.addClass("sticky-row");
                                masterRow.css("top", top);
                            }
                        }
                    }
                    else {
                        masterRow.removeClass("sticky-row");
                        masterRow.find("td").each(function (j) {
                            masterRow.find("td").eq(j).css("width", "");
                            masterRow.find("td").eq(j).find(".k-icon").width("");
                        });
                    }
                    if ($(detailsRow).is(":visible") && tools.isOnScreen(gridContent[0], detailsRow, masterRow.height() + detailsHeader.height())) {
                        if (tools.isOnScreen(gridContent[0], stickyHeader) && detailsHeader.hasClass("sticky-header")) {
                            detailsHeader.removeClass("sticky-header");
                            detailsHeader.find("th").each(function (j) {
                                detailsHeader.find("th").eq(j).css("width", "");
                                detailsHeader.find("th").eq(j).find("a").css("width", "");
                            });
                            stickyHeader.hide();
                        }
                        else {
                            if (tools.isOnScreen(gridContent[0], detailsHeader) && !detailsHeader.hasClass("sticky-header")) {
                                stickyHeader.hide();
                            }
                            else {
                                stickyHeader.show();
                                stickyHeader.find("th").each(function (j) {
                                    detailsHeader.find("th").eq(j).width($(this).width());
                                    detailsHeader.find("th").eq(j).find("a").width($(this).width());
                                });
                                detailsHeader.addClass("sticky-header");
                                top = gridContent.scrollTop();
                                var masterRowOffset = 0;
                                if (masterRowPrev && masterRowPrev.length > 0) {
                                    masterRowOffset = top - Math.abs(masterRowPrev.position().top) + 7;
                                }
                                else if (masterRowNext && masterRowNext.length > 0) {
                                    masterRowOffset = (masterRowNext.height() - 7) * -1;
                                }
                                detailsHeader.css("top", top - masterRowOffset);
                            }
                        }
                    }
                    else {
                        detailsHeader.removeClass("sticky-header");
                        stickyHeader.hide();
                        detailsHeader.find("th").each(function (j) {
                            detailsHeader.find("th").eq(j).css("width", "");
                            detailsHeader.find("th").eq(j).find("a").css("width", "");
                        });
                    }
                }
            }
        };
        KendoUtils.prototype.resizeAutoWidthRunner = function (gridContainer, autoWidthRunner) {
            var self = this;
            if (autoWidthRunner) {
                clearTimeout(autoWidthRunner);
            }
            return autoWidthRunner = setTimeout(function () {
                self.resizeAutoWidth($(gridContainer));
            }, 100);
        };
        KendoUtils.prototype.resizeAutoWidth = function (gridContainer) {
            var self = this;
            //var gridContainer = $(self.gridContainer);
            var grid = gridContainer.data("kendoGrid");
            if (gridContainer.data("skip-auto-resize")) {
                return;
            }
            // Calculate columns width
            var minWidth = self.defaultOptions.minWidth.minWidth, headerTable = gridContainer.find(".k-grid-header:first .k-grid-header-wrap"), 
            //headerTable = gridContainer.find(".k-grid-header:last"),
            headers = headerTable.find("th:visible"), emptyInitialColumns = [], allColumns = [], gridWidth = headerTable.innerWidth(), totalCalculatedWidth = 0, index = 0, width = 0, spaceAvailable, padding = 0;
            //if kendo grid is of different structure, then using simplified column stretching
            if (gridContainer.data("simplified-column-stretching") && !headerTable.length) {
                gridContainer.find("th.k-header").each(function (index, element) {
                    var th = $(element);
                    if (!th.data("width")) {
                        th.css("width", "100%");
                        console.log("simplified-column-stretching - Grid id: %s", $(gridContainer).attr("id"));
                    }
                });
            }
            var columnsDef = self.getVisibleGridColumns(grid);
            var correctedIndex = 0;
            var cols = headerTable.find("colgroup:first col");
            if (cols.length - columnsDef.length > 1) {
                return;
            }
            cols.each(function (idx, element) {
                var headerColumn = headers[index], cssStyle = $(element).css("width") ? $(element).css("width") : (headerColumn ? $(headerColumn).data("width") : null) || "0px", isAutoWidth = $(element).data("auto") || $(element).css("width") === "0px", percent, width, needAutomaticResize = false;
                if (idx === 0) {
                    correctedIndex = $(element).hasClass("k-hierarchy-col") ? 1 : 0;
                }
                var columnDef = {};
                if (!$(element).hasClass("k-hierarchy-col")) {
                    columnDef = columnsDef[idx - correctedIndex];
                    if (columnDef) {
                        isAutoWidth = !columnDef.width;
                    }
                    else {
                        isAutoWidth = false;
                    }
                }
                $(element).data("auto", isAutoWidth);
                // If column width is set to percentage, calculate it's width
                if (cssStyle.indexOf("%") > 0) {
                    percent = parseInt(cssStyle);
                    width = Math.round(gridWidth * percent / 100);
                    needAutomaticResize = true;
                    isAutoWidth = true;
                    if (width < minWidth) {
                        width = minWidth;
                    }
                }
                else {
                    width = parseInt(cssStyle);
                }
                allColumns[index] = {
                    width: isAutoWidth ? 0 : width,
                    needAutomaticResize: needAutomaticResize,
                    autoWidthColumn: isAutoWidth,
                    /*columnDef: columnDef,
                    headerTable: headerTable,
                    gridContainer: self.gridContainer,
                    headers: headers,*/
                };
                if (isAutoWidth || width === 0) {
                    emptyInitialColumns.push(index);
                }
                else {
                    totalCalculatedWidth += width;
                }
                index++;
            });
            if (emptyInitialColumns.length > 0) {
                spaceAvailable = gridWidth - totalCalculatedWidth;
                if (spaceAvailable < 0) {
                    spaceAvailable = 0;
                }
                width = Math.floor(spaceAvailable / emptyInitialColumns.length);
                if (width < minWidth) {
                    width = minWidth;
                }
                index = 0;
                var resetAutoWidth = false;
                headers.each(function (idx, element) {
                    var th = $(element);
                    if (!allColumns[index]) {
                        return;
                    }
                    if (allColumns[index].width === 0 || allColumns[index].needAutomaticResize || allColumns[index].autoWidthColumn) {
                        var setWidth = allColumns[index].width;
                        if (setWidth === 0) {
                            setWidth = width;
                        }
                        setWidth -= padding;
                        var widthAsString = setWidth + "px";
                        if (resetAutoWidth || th.outerWidth() > minWidth && allColumns[index].autoWidthColumn) {
                            resetAutoWidth = true;
                            widthAsString = "";
                        }
                        $(".k-grid-header-wrap:first", gridContainer) //header
                            .find("colgroup col")
                            .eq(index)
                            .css({ width: widthAsString });
                        $(".k-grid-content", gridContainer) //content
                            .find("colgroup col")
                            .eq(index)
                            .css({ width: widthAsString });
                        $(".k-grid-footer", gridContainer) //footer
                            .find("colgroup col")
                            .eq(index)
                            .css({ width: widthAsString });
                    }
                    index++;
                });
            }
            /*console.log($(".k-grid-header-wrap:first", gridContainer));
            console.log($(".k-grid-content", gridContainer));
            console.log($(".k-grid-footer", gridContainer));
    
            console.log(allColumns);*/
        };
        KendoUtils.prototype.destroyGrid = function () {
            var self = this;
            var grid = $(self.gridContainer).data("kendoGrid");
            grid.destroy();
            $('.k-pager-wrap, .k-grid-header, .k-grid-content', self.gridContainer).remove();
        };
        KendoUtils.prototype.getGridData = function () {
            var self = this;
            return $(self.gridContainer).data("kendoGrid");
        };
        KendoUtils.prototype.getSelectedRowsCount = function () {
            var self = this;
            return $(self.gridContainer + " .check-row:checked").length;
        };
        KendoUtils.prototype.getTotalRowsCount = function () {
            var self = this;
            var grid = $(self.gridContainer).data("kendoGrid");
            grid.dataSource.total();
        };
        KendoUtils.prototype.getSelectedRows = function () {
            var self = this;
            var grid = $(self.gridContainer).data("kendoGrid");
            var dataItems = [];
            var trs = $(self.gridContainer).find("tr");
            for (var i = 0; i < trs.length; i++) {
                if ($(trs[i]).find(":checkbox").is(":checked")) {
                    var dataItem = grid.dataItem(trs[i]);
                    dataItems.push(dataItem);
                }
            }
            return dataItems;
        };
        KendoUtils.prototype.refresh = function () {
            var self = this;
            var grid = $(self.gridContainer).data("kendoGrid");
            grid.dataSource.read();
        };
        KendoUtils.prototype.getVisibleColumnIndex = function (fieldName) {
            var self = this;
            var index = -1;
            var columnIndex = -1;
            ko.utils.arrayForEach(self.getGridData().columns, function (column) {
                if (!column.hidden) {
                    index++;
                }
                if (column.field === fieldName) {
                    columnIndex = index;
                }
            });
            return columnIndex;
        };
        KendoUtils.prototype.getVisibleColumns = function () {
            var self = this;
            var index = -1;
            var columnIndex = -1;
            var columns = ko.utils.arrayFilter(self.getGridData().columns, function (column) {
                return !column.hidden;
            });
            return columns;
        };
        KendoUtils.prototype.getVisibleGridColumns = function (grid) {
            var self = this;
            if (!grid) {
                return [];
            }
            var flattedColumns = [];
            for (var i = 0; i < grid.columns.length; i++) {
                var column = grid.columns[i];
                if (!column.columns || column.columns.length === 0) {
                    flattedColumns.push(column);
                }
                if (column.columns) {
                    for (var j = 0; j < column.columns.length; j++) {
                        var subColumn = column.columns[j];
                        if (subColumn.field) {
                            subColumn.parentTitle = column.title;
                            flattedColumns.push(subColumn);
                        }
                    }
                }
            }
            var columns = ko.utils.arrayFilter(flattedColumns, function (column) {
                return !column.hidden;
            });
            return columns;
        };
        KendoUtils.prototype.resizeColumn = function (fieldName, width) {
            var self = this;
            var index = self.getVisibleColumnIndex(fieldName);
            //var index = $(self.gridContainer + " .k-grid-header-wrap").find("th:contains(" + title + ")").index();
            //var index = $(self.gridContainer + " .k-grid-header-wrap").find('th[data-field="' + fieldName + '"]').index();
            $(self.gridContainer + " .k-grid-header-wrap") //header
                .find("colgroup col")
                .eq(index)
                .css({ width: width });
            $(self.gridContainer + " .k-grid-content") //content
                .find("colgroup col")
                .eq(index)
                .css({ width: width });
        };
        KendoUtils.prototype.setDataSource = function (data) {
            var self = this;
            var gridData = $(self.gridContainer).data("kendoGrid");
            var dataSourceOptions = self.defaultDataSource;
            dataSourceOptions["data"] = data;
            delete dataSourceOptions.schema.total;
            delete dataSourceOptions.schema.data;
            var dataSource = new kendo.data.DataSource(dataSourceOptions);
            gridData.setDataSource(dataSource);
            gridData.saveChanges();
        };
        KendoUtils.prototype.setExportDetailsDataSource = function (data) {
            var self = this;
            self.detailsDataSource = data;
        };
        KendoUtils.prototype.resizeAutoHeight = function (offSet) {
            var self = this;
            var gridElement = $(self.gridContainer), newHeight = window.innerHeight - offSet, otherElements = gridElement.children().not(".k-grid-content"), otherElementsHeight = 0;
            if (!$(".breadcrumbs").length) {
                newHeight += 42;
            }
            //$(self.gridContainer).height(newHeight);
            $(self.gridContainer).height('100%');
            otherElements.each(function (index, elm) {
                otherElementsHeight += $(elm).outerHeight();
            });
            var contentHeight = newHeight - otherElementsHeight;
            if (contentHeight < 200) {
                contentHeight = 200;
            }
            gridElement.children(".k-grid-content").height(contentHeight);
            console.log('resizeAutoHeight: offSet: ' + offSet + ' - contentHeight: ' + contentHeight);
        };
        KendoUtils.prototype.fitHeightToParent = function (parentHeight) {
            var self = this;
            var gridElement = $(self.gridContainer), newHeight = parentHeight, otherElements = gridElement.children().not(".k-grid-content"), otherElementsHeight = 0;
            $(self.gridContainer).height(newHeight);
            otherElements.each(function (index, elm) {
                otherElementsHeight += $(elm).outerHeight();
            });
            var contentHeight = newHeight - otherElementsHeight;
            if (contentHeight < 200) {
                contentHeight = 200;
            }
            gridElement.children(".k-grid-content").height(contentHeight);
            console.log('fitHeightToParent: parentHeight: ' + parentHeight + ' - contentHeight: ' + contentHeight);
        };
        KendoUtils.prototype.redrawRow = function (row, grid) {
            var self = this;
            if (!grid) {
                grid = $(self.gridContainer).data("kendoGrid");
            }
            var dataItem = grid.dataItem(row);
            var rowChildren = $(row).children('td[role="gridcell"]');
            for (var i = 0; i < grid.columns.length; i++) {
                var column = grid.columns[i];
                var template = column.template;
                var cell = rowChildren.eq(i);
                if (template !== undefined) {
                    var kendoTemplate = kendo.template(template);
                    // Render using template
                    cell.html(kendoTemplate(dataItem));
                }
                else {
                    var fieldValue = dataItem[column.field];
                    var format = column.format;
                    var values = column.values;
                    if (values !== undefined && values != null) {
                        // use the text value mappings (for enums)
                        for (var j = 0; j < values.length; j++) {
                            var value = values[j];
                            if (value.value === fieldValue) {
                                cell.html(value.text);
                                break;
                            }
                        }
                    }
                    else if (format !== undefined) {
                        // use the format
                        cell.html(kendo.format(format, fieldValue));
                    }
                    else {
                        // Just dump the plain old value
                        cell.html(fieldValue);
                    }
                }
            }
        };
        KendoUtils.prototype.showLoading = function (show) {
            var self = this;
            var element = $(self.gridContainer /*+ ' .k-grid-content'*/);
            kendo.ui.progress(element, show);
        };
        KendoUtils.prototype.exportTo = function (includeDetails) {
            if (includeDetails === void 0) { includeDetails = false; }
            var self = this;
            if (self.options.enableExport) {
                var exportModule = new ExportData();
                exportModule.openExportToExcel(self.gridId, self.options.enableExport.title, self.options.enableExport.entityName, self, includeDetails);
            }
            else {
                tools.error("export is not enabled on this table");
            }
        };
        KendoUtils.prototype.exportToMaterial = function (includeDetails) {
            if (includeDetails === void 0) { includeDetails = false; }
            var self = this;
            if (self.options.enableExport) {
                var exportModule = new ExportData();
                exportModule.openExportToExcelMaterial(self.gridId, self.options.enableExport.title, self.options.enableExport.entityName, self, includeDetails);
            }
            else {
                tools.error("export is not enabled on this table");
            }
        };
        KendoUtils.getGridSettings = function (gridId) {
            var settingsStr = localStorage["user-settings"];
            var settings = settingsStr ? JSON.parse(settingsStr) : {};
            var gridsSettings = settings["gridsSettings"] || {};
            return gridsSettings[gridId] ? gridsSettings[gridId] : null;
        };
        KendoUtils.getGridRowDataItem = function (element) {
            var grid = $(element).closest(".k-grid").data("kendoGrid");
            var row = $(element).closest("tr");
            return grid.dataItem(row);
        };
        KendoUtils.removeGridRow = function (element) {
            var grid = $(element).closest(".k-grid").data("kendoGrid");
            var row = $(element).closest("tr");
            grid.removeRow(row);
        };
        KendoUtils.destroyCombobox = function (combobox) {
            if (combobox) {
                combobox.destroy();
                var popup = combobox.popup;
                var element = popup.wrapper[0] ? popup.wrapper : popup.element;
                //remove popup element;
                element.remove();
                combobox.element.removeData("kendoComboBox");
                log.log("combobox.destroy");
            }
        };
        return KendoUtils;
    }());
    exports.KendoUtils = KendoUtils;
});
//# sourceMappingURL=kendoUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/kendoUtils.js
// module id = 6
// module chunks = 2